module.exports = __webpack_public_path__ + "10291ecf570049ea5622c536fdf01922.svg";